module.exports = __webpack_public_path__ + "assets/img/index3.fa3df63c.jpg";